import { FC } from 'react';
import { SVGProps } from './types';
export const SVGCheckGreen: FC<SVGProps> = props => {
  return (
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4.45455 8.70149L1.11364 5.25373L0 6.40299L4.45455 11L14 1.14925L12.8864 0L4.45455 8.70149Z" fill="#50C468" />
    </svg>
  );
};
